import React from 'react';
import { isValidDate } from '@/utils/helpers';

const CreatedAtCell = ({
    createdAt,
    user,
    showRole = true,
    layout = 'vertical', // mặc định 2 hàng như ban đầu
    label,
}) => {
    if (!createdAt) {
        //return <span style={{ color: '#bfbfbf' }}>—</span>;
    }

    // ===== MẶC ĐỊNH: 2 HÀNG =====
    if (layout !== 'horizontal') {
        return (
            <div style={{ lineHeight: 1.5 }}>
                {/* Ngày tạo */}
                <div>{isValidDate(createdAt, true)}</div>

                {/* Người tạo */}
                {user?.full_name && (
                    <div>
                        {showRole && user.user_role?.name && (
                            <span style={{ color: '#999', fontSize: 13.5 }}>
                                {user.user_role.name}:{' '}
                            </span>
                        )}
                        <span style={{ fontWeight: 600, fontSize: 13.5 }}>
                            {user.full_name}
                        </span>
                    </div>
                )}
            </div>
        );
    }

    // ===== 1 HÀNG (horizontal) =====
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                whiteSpace: 'nowrap',
            }}
        >
            {/* label nếu có */}
            {label && (
                <span
                    style={{
                        color: '#000000d9',
                        fontSize: 15,
                        marginRight: 4,
                        fontWeight: 500,
                    }}
                >
                    {label}:
                </span>
            )}

            <span>{isValidDate(createdAt, true)}</span>

            {user?.full_name && (
                <span>
                    <span style={{ marginRight: '6px' }}>-</span>

                    {showRole && user.user_role?.name && (
                        <span
                            style={{
                                color: '#999',
                                fontSize: 13.5,
                                marginRight: 2,
                            }}
                        >
                            {user.user_role.name}:
                        </span>
                    )}

                    <span style={{ fontWeight: 600, fontSize: 13.5 }}>
                        {user.full_name}
                    </span>
                </span>
            )}
        </div>
    );
};

export default CreatedAtCell;
